import { convertToRupiah } from '../../../helper/Rupiah'
import styles from './VendorTableItem.module.css'

const EMPTY_LABEL = 'Belum diisi'

// Deposit isian finance (deposit_manual): siapa dan kapan mengisi, tampil sebagai tooltip saat hover
const manualDepositInfo = (data) =>
  data.deposit_manual != null ? `Diisi oleh ${data.deposit_manual_by} pada ${data.deposit_manual_at}` : null

const VendorTableItem = (props) => {
  const data = props.data
  // pendingDeposit: undefined = tidak diubah; null/angka = nilai baru yang belum disimpan
  const changed = props.pendingDeposit !== undefined
  const shown = changed ? props.pendingDeposit : data.deposit_manual

  // Hanya angka; kosong = kembali "Belum diisi"
  const changeHandler = (e) => {
    const digits = e.target.value.replace(/\D/g, '')
    props.onChangeDeposit(data, digits === '' ? null : Number(digits))
  }

  const depositCell = () => {
    const info = manualDepositInfo(data)

    if (!props.editableDeposit) {
      return info ? (
        <span className={styles.hasInfo} title={info}>
          Rp. {convertToRupiah(data.deposit)}
        </span>
      ) : (
        <>Rp. {convertToRupiah(data.deposit)}</>
      )
    }

    // Gaya sama dengan sel Deposit di sub menu lain; lebar input persis mengikuti isinya (sizer)
    const text = shown == null ? '' : convertToRupiah(shown)
    let tooltip = info || 'Klik untuk mengisi deposit'
    if (changed) {
      tooltip = 'Belum disimpan'
    }

    return (
      <label className={`${styles.deposit} ${changed ? styles.changed : ''}`} title={tooltip}>
        {text !== '' && <span>Rp.</span>}
        <span className={styles.sizer} data-value={text || EMPTY_LABEL}>
          <input
            type="text"
            inputMode="numeric"
            size={1}
            value={text}
            onChange={changeHandler}
            placeholder={EMPTY_LABEL}
            className={styles.input}
          />
        </span>
        <i className={`fa fa-pencil ${styles.editIcon}`} aria-hidden="true" />
      </label>
    )
  }

  return (
    <tr>
      <td>{props.no}</td>
      <td>{data.project_id}</td>
      <td>{data.id_survey || '-'}</td>
      <td>{data.project_name}</td>
      <td>{data.client_name}</td>
      {props.dateColumns.map((c) => (
        <td key={c.key}>{data[c.key] || '-'}</td>
      ))}
      {props.showValue && (
        <td>{data.nilai_penawaran == null ? '-' : `Rp. ${convertToRupiah(data.nilai_penawaran)}`}</td>
      )}
      <td>{depositCell()}</td>
      <td>{data.payment_method ? data.payment_method : '-'}</td>
      <td>{data.payment_channel ? data.payment_channel : '-'}</td>
      <td>{data.fee_transfer}</td>
    </tr>
  )
}

export default VendorTableItem
